import { IApplicationState } from '../../types/redux';

export function selectRegionsByID(state: IApplicationState) {
  const { regionInfo } = state;
  const { regionsByID } = regionInfo;

  return regionsByID;
}
